var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWhychooseCicd(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 274,
    height: 428,
    viewBox: "0 0 274 428",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6245_97918)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_6245_97918)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6245_97918)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.099 569.309L194.098 569.309C194.094 569.308 194.091 569.307 194.087 569.307C194.085 569.306 194.082 569.306 194.079 569.305C194.064 569.302 194.049 569.299 194.035 569.296C194.052 569.3 194.069 569.304 194.087 569.307C194.091 569.307 194.094 569.308 194.098 569.309L194.099 569.309ZM139.266 491.591C139.267 491.579 139.269 491.568 139.27 491.556C139.273 491.542 139.275 491.529 139.278 491.515C139.272 491.54 139.269 491.566 139.266 491.591Z",
    fill: "url(#paint0_linear_6245_97918)"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M194.098 569.309L194.087 569.307L194.079 569.305C194.086 569.307 194.093 569.308 194.099 569.309L194.098 569.309ZM273.868 501.116V501.117C273.868 501.166 273.869 501.214 273.869 501.263C273.869 501.214 273.868 501.165 273.868 501.116ZM128.48 387.399C124.864 395.123 112.46 408.45 112.46 408.45L107.962 412.445C103.531 416.775 98.6567 419.365 96.6128 420.276C87.3168 424.924 76.8815 427.436 65.9178 427.145C29.9392 426.239 0.928389 396.216 0.0367662 358.965V357.12C0.0367662 356.914 0.0349201 356.71 0.0330798 356.507C0.0294163 356.103 0.0257756 355.701 0.0367662 355.291C0.911878 318.057 29.9227 288.034 65.9178 287.111C77.608 286.821 88.6872 289.692 98.429 294.938C104.902 298.235 112.678 297.108 117.797 291.81L140.946 267.854C147.254 261.326 148.707 251.466 144.959 243.093C141.194 234.703 138.981 225.408 138.734 215.616C138.536 208.047 139.543 200.716 141.541 193.813C142.597 190.104 143.918 186.516 145.52 183.081C149.136 175.358 147.666 166.13 141.805 160.064L117.913 135.338C112.745 129.99 104.852 128.879 98.33 132.314C89.6614 136.876 79.9196 139.576 69.5999 139.867C31.194 140.943 -0.78881 107.947 0.152348 68.2009C1.02746 30.9668 30.0382 0.943698 66.0334 0.0209626C104.439 -0.953036 136.34 32.1458 135.283 71.8918C135.002 82.5716 132.393 92.6534 127.985 101.624C124.666 108.374 125.739 116.525 130.907 121.89L154.056 145.847C160.364 152.375 169.891 153.879 177.982 150C186.089 146.104 195.071 143.814 204.532 143.558C242.938 142.481 274.921 175.477 273.98 215.223C273.369 241.265 258.971 263.77 238.067 275.27C237.968 275.324 237.866 275.38 237.764 275.436C237.544 275.558 237.318 275.683 237.093 275.799C236.68 276.021 236.267 276.244 235.855 276.449C226.36 281.302 215.677 283.933 204.417 283.608C194.592 283.335 185.28 280.874 176.925 276.705C169.462 272.963 160.545 274.484 154.684 280.55L130.792 305.276C125.624 310.624 124.55 318.792 127.869 325.542C129.223 328.276 130.379 331.129 131.37 334.068C131.376 334.097 131.386 334.126 131.397 334.153C131.402 334.167 131.407 334.18 131.412 334.193C131.421 334.216 131.429 334.237 131.436 334.256C131.766 335.23 132.08 336.221 132.36 337.212L132.608 338.084C132.839 338.904 133.054 339.707 133.235 340.527C133.351 341.04 133.467 341.57 133.582 342.082C133.623 342.278 133.666 342.475 133.708 342.671C133.803 343.108 133.899 343.548 133.978 343.996C134.127 344.765 134.243 345.534 134.358 346.303C134.379 346.438 134.401 346.572 134.424 346.708C134.473 347.001 134.522 347.298 134.556 347.602C134.705 348.661 134.804 349.738 134.903 350.831C134.903 350.945 134.918 351.059 134.932 351.173C134.94 351.23 134.947 351.287 134.953 351.344C135.101 353.241 135.167 355.172 135.167 357.12C135.167 360.281 134.986 363.391 134.589 366.432C134.567 366.637 134.531 366.842 134.494 367.047C134.476 367.15 134.457 367.253 134.441 367.355C134.409 367.565 134.378 367.775 134.347 367.985C134.25 368.646 134.153 369.304 134.028 369.953C133.925 370.518 133.807 371.075 133.69 371.63C133.637 371.88 133.584 372.13 133.533 372.379L133.503 372.524C133.447 372.804 133.388 373.093 133.318 373.37C132.179 378.274 130.561 382.973 128.48 387.399Z",
    fill: "url(#paint1_linear_6245_97918)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M68.5553 122.868C96.9889 122.868 120.025 99.5982 120.007 70.894C119.989 42.1898 96.925 18.9204 68.4914 18.9204C40.0578 18.9204 17.0221 42.1898 17.0398 70.894C17.0574 99.5982 40.1217 122.868 68.5553 122.868Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.477 215.209C259.319 186.816 236.72 163.124 207.999 162.292C179.278 161.459 155.313 183.801 154.471 212.194C153.628 240.587 176.228 264.279 204.949 265.112C233.669 265.944 257.635 243.602 258.477 215.209Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.0078 407.924C95.4414 407.924 118.477 384.898 118.46 356.493C118.442 328.089 95.3781 305.062 66.9445 305.062C38.5109 305.062 15.4751 328.089 15.4926 356.493C15.51 384.898 38.5742 407.924 67.0078 407.924Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip2_6245_97918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M73.31 364.091C72.7292 364.091 72.2578 364.562 72.2578 365.143C72.2578 365.724 72.7292 366.195 73.31 366.195C73.8908 366.195 74.3621 365.724 74.3621 365.143C74.3621 364.562 73.8907 364.091 73.31 364.091Z",
    fill: "url(#paint2_linear_6245_97918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.4837 352.94L71.1193 351.575C71.1807 351.174 71.211 350.789 71.211 350.413C71.211 350.037 71.1809 349.652 71.1193 349.251L73.4837 347.886C73.9867 347.595 74.1591 346.952 73.8686 346.449L71.7644 342.804C71.6249 342.562 71.3952 342.386 71.1256 342.314C70.8558 342.241 70.5688 342.279 70.3272 342.419L67.9534 343.79C67.3474 343.32 66.6775 342.937 65.9503 342.645V339.576C65.9503 338.995 65.4793 338.524 64.8982 338.524H60.6897C60.1085 338.524 59.6375 338.995 59.6375 339.576V342.647C58.9156 342.939 58.2398 343.325 57.6365 343.79L55.2606 342.419C54.7573 342.128 54.1141 342.301 53.8234 342.804L51.7192 346.449C51.4288 346.952 51.6011 347.595 52.1042 347.886L54.4686 349.251C54.4071 349.652 54.3768 350.037 54.3768 350.413C54.3768 350.79 54.407 351.174 54.4686 351.575L52.1042 352.94C51.6011 353.231 51.4288 353.874 51.7192 354.377L53.8234 358.022C54.114 358.525 54.7575 358.698 55.2606 358.407L57.6365 357.036C58.2398 357.501 58.9155 357.887 59.6375 358.179V360.934C59.6375 361.515 60.1085 361.986 60.6897 361.986H64.8982C65.4793 361.986 65.9503 361.515 65.9503 360.934V358.18C66.6774 357.889 67.3474 357.506 67.9534 357.036L70.3272 358.407C70.5687 358.547 70.8561 358.585 71.1256 358.512C71.3952 358.44 71.6249 358.264 71.7644 358.022L73.8686 354.377C74.1591 353.874 73.9867 353.231 73.4837 352.94ZM70.4681 356.058L68.3618 354.842C67.9591 354.61 67.4516 354.669 67.1136 354.988C66.4108 355.651 65.5635 356.136 64.5948 356.427C64.1502 356.561 63.846 356.971 63.846 357.435V359.882H61.7418V357.435C61.7418 356.971 61.4375 356.561 60.9931 356.427C60.0242 356.136 59.1772 355.652 58.4758 354.989C58.1378 354.669 57.6301 354.61 57.2272 354.842L55.1199 356.059L54.0677 354.236L56.172 353.021C56.575 352.788 56.7772 352.319 56.6692 351.866C56.5426 351.335 56.4811 350.86 56.4811 350.413C56.4811 349.966 56.5426 349.49 56.6692 348.96C56.7771 348.507 56.5749 348.037 56.172 347.805L54.0677 346.59L55.1199 344.767L57.2272 345.984C57.6302 346.216 58.1377 346.157 58.4758 345.837C59.1772 345.174 60.0241 344.69 60.9931 344.398C61.4376 344.265 61.7418 343.855 61.7418 343.391V340.628H63.846V343.391C63.846 343.855 64.1503 344.265 64.5948 344.399C65.5635 344.69 66.4108 345.174 67.1136 345.838C67.4516 346.157 67.9592 346.216 68.3618 345.984L70.4681 344.767L71.5203 346.59L69.4159 347.805C69.0129 348.038 68.8108 348.507 68.9187 348.96C69.0452 349.491 69.1067 349.966 69.1067 350.413C69.1067 350.86 69.0452 351.336 68.9187 351.866C68.8108 352.319 69.0129 352.788 69.4159 353.021L71.5203 354.236L70.4681 356.058Z",
    fill: "url(#paint3_linear_6245_97918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.7866 346.205C60.4661 346.205 58.5781 348.092 58.5781 350.413C58.5781 352.734 60.466 354.622 62.7866 354.622C65.1072 354.622 66.9952 352.734 66.9952 350.413C66.9952 348.093 65.1073 346.205 62.7866 346.205ZM62.7866 352.517C61.6264 352.517 60.6824 351.573 60.6824 350.413C60.6824 349.253 61.6264 348.309 62.7866 348.309C63.9469 348.309 64.8909 349.253 64.8909 350.413C64.891 351.573 63.947 352.517 62.7866 352.517Z",
    fill: "url(#paint4_linear_6245_97918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.1021 364.091H54.3725C53.7913 364.091 53.3203 364.562 53.3203 365.143C53.3203 365.724 53.7913 366.195 54.3725 366.195H69.1021C69.6833 366.195 70.1543 365.724 70.1543 365.143C70.1543 364.562 69.6833 364.091 69.1021 364.091Z",
    fill: "url(#paint5_linear_6245_97918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.7747 351.465H86.9871V337.156C86.987 335.416 85.5711 334 83.8307 334H43.2189C41.4785 334 40.0625 335.416 40.0625 337.156V367.247C40.0625 368.987 41.4784 370.403 43.2189 370.403H49.1108V377.195C49.1108 377.593 49.3353 377.957 49.6911 378.135C49.8403 378.21 50.0019 378.247 50.1628 378.247C50.3854 378.247 50.6066 378.176 50.7917 378.038L55.4235 374.585V378.399C55.4235 380.14 56.8394 381.556 58.5799 381.556H77.8381L85.2604 387.755C85.4534 387.916 85.693 388 85.9351 388C86.0863 388 86.2383 387.967 86.3806 387.901C86.7506 387.728 86.987 387.356 86.987 386.948V381.556H90.7746C92.5151 381.556 93.931 380.14 93.931 378.399V354.621C93.9311 352.881 92.5151 351.465 90.7747 351.465ZM51.215 375.098V369.351C51.215 368.77 50.744 368.299 50.1628 368.299H43.2189C42.6387 368.299 42.1667 367.827 42.1667 367.247V337.156C42.1667 336.576 42.6387 336.104 43.2189 336.104H83.8307C84.4108 336.104 84.8828 336.576 84.8828 337.156V367.247C84.8828 367.827 84.4108 368.299 83.8307 368.299H60.6841C60.4574 368.299 60.2369 368.372 60.0553 368.508L51.215 375.098ZM91.8268 378.399C91.8268 378.98 91.3548 379.452 90.7746 379.452H85.9349C85.3537 379.452 84.8827 379.923 84.8827 380.504V384.698L78.8942 379.696C78.705 379.538 78.4663 379.452 78.2197 379.452H58.5799C57.9997 379.452 57.5277 378.98 57.5277 378.4V373.017L61.0331 370.403H83.8307C85.5711 370.403 86.987 368.987 86.987 367.247V353.569H90.7746C91.3548 353.569 91.8268 354.041 91.8268 354.622V378.399Z",
    fill: "url(#paint6_linear_6245_97918)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip3_6245_97918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.7833 79.3333H49.95C45.5614 79.338 42.0047 82.8946 42 87.2833V96.1166C42 96.6044 42.3955 96.9999 42.8833 96.9999H65.85C66.3378 96.9999 66.7333 96.6044 66.7333 96.1166V87.2833C66.7286 82.8946 63.172 79.338 58.7833 79.3333ZM58.6207 85.3303L56.0315 84.8981L58.1898 82.3076L58.6207 85.3303ZM56.8963 81.0999L54.3667 84.1359L51.837 81.0999H56.8963ZM50.5435 82.3085L52.7018 84.8981L50.1126 85.3294L50.5435 82.3085ZM43.7667 87.2833C43.7723 84.2697 45.9474 81.6986 48.9183 81.1935L48.192 86.2744C48.1523 86.5535 48.2476 86.8343 48.449 87.0314C48.6504 87.228 48.9338 87.3169 49.2116 87.2707L53.4833 86.5591V95.2333H48.1833V87.2833H46.4167V95.2333H43.7667V87.2833ZM64.9667 95.2333H62.3167V87.2833H60.55V95.2333H55.25V86.5591L59.5217 87.2707C59.7995 87.3169 60.0829 87.228 60.2843 87.0314C60.4857 86.8343 60.5811 86.5535 60.5414 86.2744L59.815 81.1935C62.7859 81.6982 64.9615 84.2697 64.9667 87.2833V95.2333Z",
    fill: "url(#paint7_linear_6245_97918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M60.5547 73.15V70.5C61.0425 70.5 61.438 70.1045 61.438 69.6167C61.438 65.7137 58.2743 62.55 54.3714 62.55C50.4684 62.55 47.3047 65.7137 47.3047 69.6167C47.3047 70.1045 47.7002 70.5 48.188 70.5V73.15C48.188 76.5652 50.9562 79.3334 54.3714 79.3334C57.7865 79.3334 60.5547 76.5652 60.5547 73.15ZM54.3714 64.3167C56.8963 64.3202 59.0697 66.1011 59.5687 68.576C58.4844 68.155 57.5467 67.4252 56.873 66.4763C56.7263 66.2563 56.4887 66.114 56.2256 66.0877C56.1954 66.0877 56.1665 66.0877 56.1372 66.0877C55.903 66.0877 55.6782 66.1809 55.5126 66.3465C54.5482 67.3079 51.4759 68.1326 49.1775 68.5565C49.6843 66.0907 51.8538 64.3197 54.3714 64.3167ZM54.3714 77.5667C51.9331 77.5637 49.9577 75.5883 49.9547 73.15L49.9486 70.2093C52.0573 69.8652 54.0975 69.1841 55.9905 68.1929C56.7557 69.0603 57.7136 69.7358 58.788 70.1645V73.15C58.785 75.5883 56.8096 77.5637 54.3714 77.5667Z",
    fill: "url(#paint8_linear_6245_97918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.1667 70.5H84.4C84.3896 79.2773 77.2773 86.3896 68.5 86.4V88.1667C78.2525 88.1555 86.1555 80.2525 86.1667 70.5Z",
    fill: "url(#paint9_linear_6245_97918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5016 52.8333C62.7595 52.8393 57.3772 55.629 54.0625 60.3179L55.5052 61.3371C58.4887 57.1171 63.3336 54.606 68.5016 54.5999V52.8333Z",
    fill: "url(#paint10_linear_6245_97918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5 89.9333V91.7C80.2029 91.6862 89.6862 82.2029 89.7 70.5H87.9333C87.9213 81.2277 79.2277 89.9213 68.5 89.9333Z",
    fill: "url(#paint11_linear_6245_97918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.4997 51.0667V49.3C60.3672 49.3294 52.9589 53.9802 49.3984 61.2923L50.9883 62.0596C54.2525 55.3566 61.0439 51.093 68.4997 51.0667Z",
    fill: "url(#paint12_linear_6245_97918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M73.8047 46.6501H75.5714V48.4168H73.8047V46.6501Z",
    fill: "url(#paint13_linear_6245_97918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4453 46.6501H78.212V48.4168H76.4453V46.6501Z",
    fill: "url(#paint14_linear_6245_97918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.1016 46.6501H80.8682V48.4168H79.1016V46.6501Z",
    fill: "url(#paint15_linear_6245_97918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M92.349 44H72.9156C71.4522 44 70.2656 45.1865 70.2656 46.65V66.0833C70.2656 67.5468 71.4522 68.7333 72.9156 68.7333H92.349C93.8124 68.7333 94.999 67.5468 94.999 66.0833V46.65C94.999 45.1865 93.8124 44 92.349 44ZM72.9156 45.7667H92.349C92.8368 45.7667 93.2323 46.1622 93.2323 46.65V49.3H72.0323V46.65C72.0323 46.1622 72.4278 45.7667 72.9156 45.7667ZM92.349 66.9667H72.9156C72.4278 66.9667 72.0323 66.5711 72.0323 66.0833V51.0667H93.2323V66.0833C93.2323 66.5711 92.8368 66.9667 92.349 66.9667Z",
    fill: "url(#paint16_linear_6245_97918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.4788 54.8586L75.8288 57.5086C75.4842 57.8537 75.4842 58.4127 75.8288 58.7577L78.4788 61.4077L79.7279 60.1586L77.7024 58.1332L79.7279 56.1077L78.4788 54.8586Z",
    fill: "url(#paint17_linear_6245_97918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M86.7882 54.8586L85.5391 56.1077L87.5645 58.1332L85.5391 60.1586L86.7882 61.4077L89.4382 58.7577C89.7828 58.4127 89.7828 57.8537 89.4382 57.5086L86.7882 54.8586Z",
    fill: "url(#paint18_linear_6245_97918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.0469 62.2226L83.5768 53.3884L85.2175 54.0436L81.6872 62.8782L80.0469 62.2226Z",
    fill: "url(#paint19_linear_6245_97918)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M223.187 197.49L224.57 196.107C224.777 195.891 224.891 195.603 224.888 195.303C224.885 195.004 224.765 194.718 224.553 194.506C224.342 194.295 224.055 194.175 223.756 194.171C223.457 194.168 223.168 194.283 222.952 194.49L219.644 197.798C219.538 197.904 219.454 198.03 219.396 198.169C219.339 198.308 219.309 198.457 219.309 198.607C219.309 198.757 219.339 198.906 219.396 199.044C219.454 199.183 219.538 199.309 219.644 199.415L222.952 202.724C223.058 202.83 223.185 202.914 223.323 202.972C223.462 203.029 223.611 203.059 223.761 203.059C223.986 203.055 224.204 202.986 224.39 202.86C224.576 202.733 224.72 202.556 224.806 202.348C224.892 202.141 224.916 201.912 224.874 201.692C224.831 201.471 224.726 201.268 224.57 201.106L223.243 199.78C226.927 199.932 230.41 201.501 232.965 204.159C235.519 206.818 236.949 210.36 236.955 214.047C236.167 233.016 209.144 233.004 208.362 214.047C208.357 209.65 206.609 205.435 203.5 202.326C200.391 199.217 196.175 197.468 191.779 197.463C170.112 198.31 169.634 229.086 191.251 230.604L189.868 231.986C189.761 232.092 189.677 232.219 189.619 232.357C189.562 232.496 189.532 232.645 189.532 232.795C189.532 232.946 189.561 233.094 189.619 233.233C189.676 233.372 189.76 233.498 189.867 233.605C189.973 233.711 190.099 233.795 190.238 233.853C190.377 233.91 190.526 233.94 190.676 233.94C190.826 233.94 190.975 233.91 191.114 233.852C191.253 233.794 191.379 233.71 191.485 233.604L194.793 230.295C194.9 230.189 194.984 230.063 195.041 229.924C195.099 229.786 195.128 229.637 195.128 229.487C195.128 229.336 195.099 229.188 195.041 229.049C194.984 228.91 194.9 228.784 194.793 228.678L191.485 225.37C191.269 225.162 190.981 225.048 190.681 225.051C190.382 225.054 190.096 225.174 189.884 225.386C189.672 225.598 189.552 225.884 189.549 226.183C189.546 226.483 189.661 226.771 189.868 226.987L191.194 228.313C172.664 226.859 173.168 200.473 191.779 199.75C195.569 199.755 199.203 201.262 201.883 203.943C204.563 206.623 206.071 210.256 206.075 214.047C206.08 218.443 207.829 222.659 210.938 225.768C214.047 228.877 218.262 230.625 222.659 230.63C244.325 229.784 244.804 199.008 223.187 197.49Z",
    fill: "url(#paint20_linear_6245_97918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M200.934 211.361H200.223C199.835 210.149 199.192 209.034 198.338 208.091L198.697 207.467C198.948 207.027 199.014 206.505 198.883 206.016C198.751 205.527 198.431 205.11 197.994 204.855L196.647 204.076C196.207 203.824 195.685 203.755 195.195 203.886C194.705 204.017 194.286 204.337 194.031 204.775L193.674 205.392C192.43 205.122 191.143 205.121 189.9 205.39C189.57 204.761 189.135 204.031 188.38 203.877C187.44 203.523 186.348 204.447 185.577 204.847C185.138 205.101 184.817 205.52 184.685 206.01C184.554 206.501 184.622 207.023 184.876 207.464L185.233 208.082C184.376 209.023 183.731 210.137 183.342 211.348H182.626C182.119 211.349 181.632 211.551 181.272 211.91C180.913 212.269 180.711 212.756 180.711 213.264V214.818C180.711 215.326 180.913 215.813 181.272 216.172C181.632 216.531 182.119 216.733 182.626 216.734H183.338C183.726 217.945 184.369 219.059 185.223 220.002L184.864 220.626C184.613 221.067 184.547 221.588 184.678 222.077C184.81 222.566 185.129 222.984 185.567 223.239L186.914 224.017C187.354 224.27 187.876 224.339 188.366 224.208C188.857 224.077 189.275 223.757 189.53 223.318L189.886 222.701C191.13 222.972 192.417 222.973 193.661 222.705L194.02 223.326C194.275 223.764 194.693 224.084 195.184 224.215C195.674 224.346 196.196 224.277 196.636 224.025C197.363 223.543 198.713 223.079 198.877 222.083C198.943 221.718 198.928 221.344 198.833 220.985C198.738 220.627 198.566 220.295 198.328 220.011C199.185 219.07 199.83 217.957 200.219 216.745H200.935C201.442 216.745 201.929 216.543 202.288 216.183C202.648 215.824 202.849 215.337 202.85 214.83V213.275C202.849 212.767 202.647 212.281 202.288 211.922C201.929 211.563 201.442 211.361 200.934 211.361ZM200.563 214.458C199.708 214.469 198.44 214.242 198.217 215.374C197.931 216.762 197.202 218.02 196.14 218.96C195.267 219.709 196.106 220.718 196.517 221.452L195.813 221.858C195.443 221.274 195.063 220.162 194.211 220.225C192.75 220.707 191.177 220.727 189.705 220.281C188.622 219.897 188.166 221.129 187.736 221.85L187.032 221.444C187.446 220.709 188.277 219.697 187.412 218.953C186.352 218.011 185.625 216.751 185.339 215.362C185.125 214.235 183.838 214.456 182.998 214.446V213.636C183.853 213.624 185.121 213.851 185.344 212.72C185.63 211.331 186.359 210.073 187.421 209.133C188.294 208.384 187.454 207.375 187.042 206.642L187.747 206.235L188.359 207.297C188.491 207.526 188.697 207.702 188.944 207.796C189.19 207.889 189.462 207.894 189.712 207.81C191.058 207.364 192.512 207.365 193.858 207.813C194.939 208.193 195.396 206.964 195.825 206.243L196.528 206.649C196.115 207.383 195.283 208.397 196.149 209.139C197.213 210.079 197.941 211.34 198.222 212.732C198.274 212.99 198.414 213.223 198.618 213.39C198.823 213.557 199.078 213.648 199.342 213.648H200.563V214.458Z",
    fill: "url(#paint21_linear_6245_97918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M191.776 209.043C190.457 209.056 189.197 209.589 188.269 210.526C187.341 211.463 186.82 212.728 186.82 214.047C186.82 215.365 187.341 216.631 188.269 217.568C189.197 218.505 190.457 219.038 191.776 219.05C193.095 219.038 194.355 218.505 195.283 217.568C196.211 216.631 196.731 215.365 196.731 214.047C196.731 212.728 196.211 211.462 195.283 210.525C194.355 209.588 193.094 209.056 191.776 209.043ZM191.776 216.763C191.061 216.755 190.377 216.465 189.874 215.957C189.371 215.448 189.089 214.762 189.089 214.047C189.089 213.331 189.371 212.645 189.874 212.136C190.377 211.628 191.061 211.338 191.776 211.33C192.491 211.338 193.175 211.627 193.679 212.136C194.182 212.644 194.464 213.331 194.464 214.047C194.464 214.762 194.182 215.449 193.679 215.958C193.175 216.466 192.491 216.756 191.776 216.763Z",
    fill: "url(#paint22_linear_6245_97918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.513 218.815C215.729 219.022 216.018 219.137 216.317 219.134C216.617 219.131 216.903 219.011 217.115 218.799C217.327 218.587 217.447 218.301 217.45 218.002C217.453 217.702 217.338 217.413 217.13 217.198L213.98 214.047L217.13 210.896C217.345 210.682 217.465 210.391 217.465 210.087C217.465 209.784 217.345 209.493 217.13 209.279C216.916 209.064 216.625 208.944 216.322 208.944C216.019 208.944 215.728 209.064 215.513 209.279L211.554 213.238C211.448 213.344 211.363 213.47 211.306 213.609C211.248 213.748 211.219 213.897 211.219 214.047C211.219 214.197 211.248 214.346 211.306 214.484C211.363 214.623 211.448 214.749 211.554 214.855L215.513 218.815Z",
    fill: "url(#paint23_linear_6245_97918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M228.187 218.815C228.293 218.921 228.419 219.005 228.558 219.063C228.696 219.12 228.845 219.15 228.995 219.15C229.145 219.15 229.294 219.12 229.433 219.063C229.572 219.005 229.698 218.921 229.804 218.815L233.763 214.855C233.87 214.749 233.954 214.623 234.011 214.484C234.069 214.346 234.098 214.197 234.098 214.047C234.098 213.897 234.069 213.748 234.011 213.609C233.954 213.47 233.87 213.344 233.763 213.238L229.804 209.279C229.698 209.173 229.572 209.088 229.433 209.031C229.294 208.973 229.145 208.944 228.995 208.944C228.845 208.944 228.696 208.973 228.558 209.031C228.419 209.088 228.293 209.173 228.187 209.279C228.08 209.385 227.996 209.511 227.939 209.65C227.881 209.789 227.852 209.937 227.852 210.087C227.852 210.238 227.881 210.386 227.939 210.525C227.996 210.664 228.08 210.79 228.187 210.896L231.337 214.047L228.187 217.198C228.08 217.304 227.996 217.43 227.939 217.569C227.881 217.707 227.852 217.856 227.852 218.006C227.852 218.156 227.881 218.305 227.939 218.444C227.996 218.583 228.08 218.709 228.187 218.815Z",
    fill: "url(#paint24_linear_6245_97918)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.283 220.262L225.252 208.385C225.319 208.093 225.269 207.787 225.112 207.531C224.956 207.276 224.705 207.092 224.415 207.02C224.124 206.947 223.817 206.992 223.559 207.143C223.3 207.295 223.112 207.542 223.034 207.831L220.065 219.708C219.992 220.002 220.038 220.314 220.194 220.573C220.35 220.833 220.603 221.021 220.897 221.094C221.192 221.168 221.503 221.121 221.763 220.965C222.023 220.809 222.21 220.556 222.283 220.262Z",
    fill: "url(#paint25_linear_6245_97918)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6245_97918",
    x: -9.36875,
    y: -9.4,
    width: 292.769,
    height: 588.109,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4.7
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.75 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6245_97918"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6245_97918",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6245_97918",
    x1: 34.25,
    y1: 139.23,
    x2: 343.807,
    y2: 235.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C84CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA64B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6245_97918",
    x1: 34.25,
    y1: 139.23,
    x2: 343.807,
    y2: 235.057,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8C84CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAA64B"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6245_97918",
    x1: 72.5209,
    y1: 364.501,
    x2: 74.0991,
    y2: 365.774,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_6245_97918",
    x1: 54.3821,
    y1: 343.099,
    x2: 71.7957,
    y2: 356.529,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_6245_97918",
    x1: 59.6303,
    y1: 347.846,
    x2: 65.943,
    y2: 352.938,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6245_97918",
    x1: 55.4246,
    y1: 364.501,
    x2: 55.9133,
    y2: 367.655,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6245_97918",
    x1: 46.7961,
    y1: 344.53,
    x2: 87.275,
    y2: 377.104,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6245_97918",
    x1: 45.0917,
    y1: 82.7783,
    x2: 58.549,
    y2: 97.976,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6245_97918",
    x1: 49.0714,
    y1: 65.8228,
    x2: 61.0441,
    y2: 73.9559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6245_97918",
    x1: 70.7083,
    y1: 73.945,
    x2: 83.9583,
    y2: 84.6333,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6245_97918",
    x1: 55.8674,
    y1: 54.4915,
    x2: 62.0829,
    y2: 63.0048,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_6245_97918",
    x1: 71.15,
    y1: 74.634,
    x2: 87.05,
    y2: 87.46,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_6245_97918",
    x1: 51.7861,
    y1: 51.7882,
    x2: 61.4059,
    y2: 63.4049,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_6245_97918",
    x1: 74.0255,
    y1: 46.9946,
    x2: 75.3505,
    y2: 48.0635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_6245_97918",
    x1: 76.6661,
    y1: 46.9946,
    x2: 77.9911,
    y2: 48.0635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_6245_97918",
    x1: 79.3224,
    y1: 46.9946,
    x2: 80.6474,
    y2: 48.0635,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_6245_97918",
    x1: 73.3573,
    y1: 48.823,
    x2: 91.9073,
    y2: 63.7867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_6245_97918",
    x1: 76.09,
    y1: 56.1357,
    x2: 80.1678,
    y2: 58.2239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_6245_97918",
    x1: 86.0588,
    y1: 56.1357,
    x2: 90.1366,
    y2: 58.2239,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_6245_97918",
    x1: 80.6932,
    y1: 55.2389,
    x2: 86.0582,
    y2: 57.597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_6245_97918",
    x1: 183.266,
    y1: 201.926,
    x2: 212.787,
    y2: 240.176,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_6245_97918",
    x1: 183.478,
    y1: 207.792,
    x2: 199.049,
    y2: 221.369,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_6245_97918",
    x1: 188.059,
    y1: 210.994,
    x2: 195.549,
    y2: 216.978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_6245_97918",
    x1: 212,
    y1: 210.931,
    x2: 218.214,
    y2: 214.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_6245_97918",
    x1: 228.632,
    y1: 210.934,
    x2: 234.85,
    y2: 214.004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_6245_97918",
    x1: 220.687,
    y1: 209.744,
    x2: 226.652,
    y2: 211.53,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#120096"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8C84CB"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6245_97918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 274,
    height: 428,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_6245_97918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 274,
    height: 714,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip2_6245_97918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 54,
    height: 54,
    fill: "white",
    transform: "translate(40 334)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip3_6245_97918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 53,
    fill: "white",
    transform: "translate(42 44)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhychooseCicd);
export default __webpack_public_path__ + "static/media/whychoose_cicd.9581ac6a3ad03567b545ef6938344bd4.svg";
export { ForwardRef as ReactComponent };